<template>
  <!--基本信息的考试须知区 -->
  <div
    class="basics-desc"
    :style="{ width: isCW ? contW + 41 + 20 + 'px' : 'auto' }"
  >
    <div class="d-name">
      <div class="n-p">
        考试
        <br />须知
      </div>
    </div>
    <div class="d-cont" >
      <p>1.答题前请将个人信息填写清楚。</p>

      <p>2.客观题答题修改时用橡皮擦干净。</p>

      <p>3.主观题必须使用黑色签字笔书写。</p>

      <p>4.请在题号对应答题区内作答,超出书写无效。</p>
      <BasicsExampleImage/>
<!-- 
      <p class="BasicsExampleImage_wrap">
      </p> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BasicsExampleImage from './BasicsExampleImage'

//基础信息区
export default {
  name: "basicsDesc",
  components:{
    BasicsExampleImage
  },
  props: {
    sty: String,
    isCW: Boolean,
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("cardMake", ["pageCellSize"]), //答卷设置参数
    contW() {
      if (this.answerSheet.acCardPanes == 3) {
        let w;
        if (this.answerSheet.acCardStudentCodeType == 1) {
          w = this.pageCellSize[1] - 301 - 2 - 41 - 20;
        } else {
          w =
            this.pageCellSize[1] -
            this.answerSheet.acCardExamNumber * 28 -
            41 -
            20 -
            2;
        }
        return w;
      } else {
        let w;
        if (this.answerSheet.acCardStudentCodeType == 1) {
          w = this.pageCellSize[0] - 301 - 2 - 41 - 20;
        } else {
          w =
            this.pageCellSize[0] -
            this.answerSheet.acCardExamNumber * 28 -
            41 -
            20 -
            2;
        }
        return w;
      }
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.isCW, "isCW");
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.basics-desc {
  border: 1px solid #000000;
  // border-top: 0;
  display: flex;
  flex-flow: row;

  .d-name {
    background: #f2f2f2;
    width: 40px;
    line-height: 25px;
    text-align: center;
    border-right: 1px solid #000000;
    display: flex;
    align-items: center;
  }

  .d-cont {
    padding: 10px;

    p {
      padding-top: 10px;
      line-height: 20px;
    }
  }

  .n-p {
    text-align: center;
    width: 100%;
  }
}
</style>
